"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTwisterchain = exports.twisterchainUseableDef = void 0;
const KetteSerieType_1 = require("./KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.twisterchainUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.twisterchain,
    },
};
exports.isTwisterchain = echain_shared_modelling_1.UseableUtil.createGuard(exports.twisterchainUseableDef);
//# sourceMappingURL=Twisterchain.js.map